module.exports = __webpack_public_path__ + "static/media/adn_dropdown_open.b88b8bb0.png";